import { startCase } from 'lodash-es'

import { LlmToolCall } from '@/libs/features/llm/types'
import { CitedContextDatapoint, LlmSourceType } from '@/libs/features/llm/types'
import { formatDate } from './ResponseContent/LlmSource/format'
import { AskAProfileTool } from './types'

const TOOL_NAME_LOOKUPS: Partial<Record<AskAProfileTool, string>> = {
  [AskAProfileTool.PERSONAL_INFORMATION]: 'Patient Sidebar',
  [AskAProfileTool.SUBTASKS]: 'subtasks',
  [AskAProfileTool.COMMUNICATIONS]: 'communications',
  [AskAProfileTool.GOALS_AND_PLAYBOOKS]: 'goals and playbooks',
  [AskAProfileTool.CLAIMS]: 'recent claims',
}

const DEFAULT_COMPLETED_TOOLS = new Set(['communications', 'subtasks'])

/**
 *
 * @param tool
 */
export function formatToolCall(tool: LlmToolCall) {
  const args = tool.args ?? {}
  const partsToRender: string[] = ['Checked']

  if (args.active_only) {
    partsToRender.push('active')
  }

  if (
    args.completed ||
    (DEFAULT_COMPLETED_TOOLS.has(tool.toolName) && args.completed !== false)
  ) {
    partsToRender.push('completed')
  }

  if (args.comm_type) {
    partsToRender.push(startCase(args.comm_type).toLowerCase())
  }

  const toolName =
    TOOL_NAME_LOOKUPS[tool.toolName as AskAProfileTool] ??
    startCase(tool.toolName)
  partsToRender.push(toolName)

  if (args.since) {
    const formattedSince = formatDate(args.since) ?? args.since

    if (args.until) {
      const formattedUntil = formatDate(args.until) ?? args.until
      partsToRender.push(`from ${formattedSince} until ${formattedUntil}`)
    } else {
      partsToRender.push(`since ${formattedSince}`)
    }
  }

  const text = partsToRender.join(' ').replaceAll(/\s+/g, ' ').trim()

  return text
}

/**
 * Filters out PROFILE citations and sorts by relevance (desc),
 * then by displayTimestamp (asc, nulls first).
 * @param citations
 */
export function sortAndFilterCitations(
  citations: CitedContextDatapoint[]
): CitedContextDatapoint[] {
  return [...citations]
    .filter((c) => c?.sourceType !== LlmSourceType.PROFILE)
    .sort((a, b) => {
      const ra = a.relevanceScore ?? 0
      const rb = b.relevanceScore ?? 0

      if (rb !== ra) return rb - ra

      const ta = a.displayTimestamp
      const tb = b.displayTimestamp

      if (!ta && !tb) return 0
      if (!ta) return -1
      if (!tb) return 1

      return Date.parse(String(ta)) - Date.parse(String(tb))
    })
}
